import React from 'react';
import { motion } from 'framer-motion';
import SugarCard from '../components/SugarCard';

const LandingScreen: React.FC = () => {
  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.5,
        type: "spring",
        stiffness: 100
      }
    })
  };

  const decorativeVariants = {
    hidden: { scaleX: 0 },
    visible: {
      scaleX: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.div
      className="bg-purple-light relative min-h-screen min-h-[100dvh] w-full flex flex-col items-center justify-center overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {/* Background decorative elements */}
      <motion.div
        className="absolute top-[270px] sm:top-[320px] md:top-[347px] left-[105px] w-[236px] h-[15px] bg-purple-card/20 rounded-full origin-left"
        variants={decorativeVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.8 }}
      />
      <motion.div
        className="absolute top-[325px] sm:top-[370px] md:top-[416px] left-[105px] w-[207px] h-[17px] bg-purple-card/15 rounded-full origin-left"
        variants={decorativeVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 1 }}
      />

      {/* Main heading */}
      <div className="absolute top-[220px] sm:top-[260px] md:top-[297px] text-center">
        <motion.h1
          className="font-medium text-[60px] leading-[70px] text-navy-dark"
          style={{ fontFamily: 'Bricolage Grotesque, system-ui, sans-serif' }}
        >
          <motion.span
            custom={0}
            variants={textVariants}
            initial="hidden"
            animate="visible"
            className="block"
          >
            Debt-Free,
          </motion.span>
          <motion.span
            custom={1}
            variants={textVariants}
            initial="hidden"
            animate="visible"
            className="block text-purple-card"
          >
            Faster
          </motion.span>
        </motion.h1>
      </div>

      {/* Sugar Card */}
      <motion.div
        className="absolute bottom-[85px]"
        animate={{ y: [0, -6, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
      >
        <SugarCard delay={0.6} />
      </motion.div>

      {/* Auto-navigate indicator */}
      {/* <motion.div
        className="absolute bottom-6 text-navy-dark/50 text-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.5 }}
      >
        <motion.div
          animate={{ opacity: [1, 0.5, 1] }}
          transition={{ repeat: Infinity, duration: 1 }}
        >
          Loading next screen...
        </motion.div>
      </motion.div> */}
    </motion.div>
  );
};

export default LandingScreen;
